import { i18n } from '../../shared/i18n'
import { readEnv } from '../runtime-env'
import { buildOAuthRedirectUri, startOAuthLoginState } from './oauth-state'

const KAKAO_SDK_URL = 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.4/kakao.min.js'

let scriptLoaded = false

function loadKakaoScript(): Promise<void> {
  if (scriptLoaded) {
    return Promise.resolve()
  }

  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${KAKAO_SDK_URL}"]`)) {
      scriptLoaded = true
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = KAKAO_SDK_URL
    script.async = true
    script.onload = () => {
      scriptLoaded = true
      resolve()
    }
    script.onerror = () => reject(new Error(i18n.t('common.errors.sdkLoadFailed')))
    document.head.appendChild(script)
  })
}

export async function signInWithKakao(): Promise<void> {
  const jsKey = readEnv('VITE_KAKAO_JAVASCRIPT_KEY')

  if (!jsKey) {
    throw new Error(i18n.t('common.errors.authConfigError'))
  }

  await loadKakaoScript()

  if (!Kakao.isInitialized()) {
    Kakao.init(jsKey)
  }

  // The callback page sends the code to the server with this state (개발항목 166).
  Kakao.Auth.authorize({
    redirectUri: buildOAuthRedirectUri('KAKAO'),
    state: startOAuthLoginState('KAKAO'),
  })
}
